import axios from 'axios';
import token from '@/utils/token';
import store from '@/store';
import baseUrl from '@/utils/api';
import { MessageBox } from 'element-ui';
// 此文件属于后期维护人员重新封装

// 创建 axios 实例
const service = axios.create({
  timeout: 60000, // 请求超时时间
});

const err = (error) => {
  if (error.response) {
    if (error.response.status === 401) {
      token.remove();
      localStorage.removeItem('choicesSchool');
      window.location.href = `${baseUrl}/sso/logout?client_id=4&redirect_uri=${window.location.origin}&response_type=token&scope=&state=4`;
    } else if (error.response.data.status === 403403 && store.state.schoolCenter) {
      window.top.postMessage({
        type: 'itCloseUser',
      }, '*');
    } else {
      return Promise.reject(error.response.data);
    }
  } else {
    MessageBox.alert('账号已过期请重新登录', '提示', {
      confirmButtonText: '确定',
      showClose: false,
      callback: () => {
        token.remove();
        localStorage.removeItem('choicesSchool');
        window.location.href = `${baseUrl}/sso/logout?client_id=4&redirect_uri=${window.location.origin}&response_type=token&scope=&state=4`;
      },
    });
  }
};

// request interceptor
service.interceptors.request.use((config) => {
  const TOKEN = token.get();
  config.headers.Accept = 'application/json'; // 规定客户端接收类型. 仅支持: application/json
  config.headers['Access-Client-Id'] = store.state.appId; // 后台client_id为4
  if (TOKEN) {
    config.headers.Authorization = `Bearer ${TOKEN}`; // 让每个请求携带自定义 token
  }
  return config;
}, err);

// response interceptor
service.interceptors.response.use(response => response.data, err);

export default service;



// WEBPACK FOOTER //
// ./src/api/http.js